/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValidateUpgradeSummary } from './validateUpgradeSummary';
import { UpgradeFailedSpec } from './upgradeFailedSpec';
import { ValidateUpgradeSpec } from './validateUpgradeSpec';


export interface ValidateUpgradeResponseSpec { 
    summary: ValidateUpgradeSummary;
    /**
     * Entities succeeded validation check.
     */
    succeeded: Array<ValidateUpgradeSpec>;
    /**
     * Entities failed validation check.
     */
    failed: Array<UpgradeFailedSpec>;
}

